import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Base from './Base';

import formatDate from 'date-fns/format';

import { hrefToNext } from 'app/common/hrefTo';

const Run = forwardRef(({ selectedNav, index, auth }, ref) => {
    return (
        <div>
            <Base ref={ref} index={index} selectedNav={selectedNav}>
                <div className="megamenu">
                    <div className="megamenu-columns">
                        <div className="primary-columns">
                            <h2>Runs</h2>
                            <div className="columns-2">
                                <div className="primary-column">
                                    <h3>Manage</h3>
                                    {auth.user.role === 'admin' && (
                                        <a
                                            href={hrefToNext(
                                                '/run/assign-contractor'
                                            )}
                                        >
                                            <div className="megamenu-link">
                                                <div className="logo-wrapper">
                                                    <div className="megamenu-icon">
                                                        <i className="fa-solid fa-truck-loading fa-fw" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <h4>Assign Contractor</h4>
                                                    <p className="link-subtext">
                                                        Assign
                                                    </p>
                                                </div>
                                            </div>
                                        </a>
                                    )}
                                    <Link
                                        to={`/run/assign/driver/1/${formatDate(new Date(), 'yyyy-MM-dd')}/rg/all/all`}
                                    >
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-solid fa-user fa-fw" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>Assign Driver</h4>
                                                <p className="link-subtext">
                                                    Assign
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link
                                        to={`/run/r/country/1/${formatDate(new Date(), 'yyyy-MM-dd')}`}
                                    >
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-solid fa-truck-bolt fa-fw" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>Run Summary</h4>
                                                <p className="link-subtext">
                                                    View
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to={`/run/r/events/all`}>
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-brands fa-elementor fa-fw" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>Run Events</h4>
                                                <p className="link-subtext">
                                                    View
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="primary-column">
                                    <h3>Manage</h3>
                                    <Link to={`/run/runs/all`}>
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-solid fa-truck-arrow-right fa-fw" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>Run List</h4>
                                                <p className="link-subtext">
                                                    View and Manage runs
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to={`/run/drops/all`}>
                                        <div className="megamenu-link">
                                            <div className="logo-wrapper">
                                                <div className="megamenu-icon">
                                                    <i className="fa-solid fa-droplet fa-fw" />
                                                </div>
                                            </div>
                                            <div>
                                                <h4>Drop List</h4>
                                                <p className="link-subtext">
                                                    View and manage drops
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="secondary-columns">
                            <ul></ul>
                        </div>
                    </div>
                </div>
            </Base>
        </div>
    );
});
Run.displayName = 'Run';
Run.propTypes = {
    selectedNav: PropTypes.any,
    index: PropTypes.any,
    auth: PropTypes.object,
};

export default Run;
